import flagtr from "../assets/images/flags/tr.svg"
import flagus from "../assets/images/flags/us.svg";
import flaggermany from "../assets/images/flags/germany.svg";

const languages = {
  tr: {
    label: "Türkce",
    flag: flagtr
  },
  en: {
    label: "English",
    flag: flagus,
  },
  gr: {
    label: "Deutsch",
    flag: flaggermany,
  },
}

export default languages
